module.exports = __webpack_public_path__ + "static/media/tz.9e509eeb.svg";